import { render, staticRenderFns } from "./pricing-card.vue?vue&type=template&id=1a6ef8e7&scoped=true&"
import script from "./pricing-card.vue?vue&type=script&lang=ts&"
export * from "./pricing-card.vue?vue&type=script&lang=ts&"
import style0 from "./pricing-card.vue?vue&type=style&index=0&id=1a6ef8e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6ef8e7",
  null
  
)

export default component.exports